const defaultData = {
  Title: { value: 'More ways to work with Manhattan office space' },
  Description: {
    value:
      'At the heart of New York is a burgeoning Manhattan. Here, we offer a number of Manhattan offices that give you the flexibility and location your business needs. Connect across the latest technology, and stay agile in an ever-changing city using our dynamic, fully serviced offerings.',
  },
  SubTitle: {
    value:
      'At the heart of New York is a burgeoning Manhattan. Here, we offer a number of Manhattan offices that give you the flexibility and location your business needs. Connect across the latest technology, and stay agile in an ever-changing city using our dynamic, fully serviced offerings.',
  },
};

export default defaultData;
